import { Icons, MenuItem } from '@silverfort/sf-components';
import { LogicalItemsTypes } from '../../../../TowerMenu/logicalMenuItems/LogicalItemsTypes';
import { PricingModules, usePricingModulesState } from '../../../../context/contexts/PricingModuleContext';
import { isUserPermitted } from '../../../../TowerMenu/TowerMenuUtils';
import { ROLES, TOWER_MENU_ITEMS } from '@silverfort-nodelibs/common/utils/consts';
import { useSassRestrictions } from '../../../../context/contexts/SassRestrictionsContext';

export const AiAgentSecurityLogicalMenuItems = ({ userData, getTowerMenuHref, ...props }: LogicalItemsTypes) => {
    const { pricingModulesState } = usePricingModulesState();
    const { restrictedSaasSupportMode } = useSassRestrictions();

    const hasCloudLicense = pricingModulesState?.[PricingModules.AI_AGENTS_SECURITY]?.cloudEnabled ?? false;
    const hasPermission: boolean = isUserPermitted(userData, 'aiAgentSecurityCloud', ROLES.VIEWER.value) ?? false;

    const hasAccessControlLicense: boolean =
        pricingModulesState?.[PricingModules.AI_AGENTS_PROTECTION]?.cloudEnabled ?? false;
    const hasAccessControlPermission: boolean =
        isUserPermitted(userData, 'aiAccessControlCloud', ROLES.VIEWER.value) ?? false;

    return (
        <MenuItem id={TOWER_MENU_ITEMS.AI_SECURITY} ItemIcon={Icons.Magic} title="AI Security" {...props}>
            <MenuItem
                disabled={restrictedSaasSupportMode || (hasCloudLicense && !hasPermission)}
                earlyAvailability={true}
                href={getTowerMenuHref(TOWER_MENU_ITEMS.AI_AGENT_SECURITY_CLOUD)}
                id={TOWER_MENU_ITEMS.AI_AGENT_SECURITY_CLOUD}
                title="Visibility"
            />
            <MenuItem
                disabled={restrictedSaasSupportMode || (hasAccessControlLicense && !hasAccessControlPermission)}
                earlyAvailability={true}
                href={getTowerMenuHref(TOWER_MENU_ITEMS.AI_AGENT_PROTECTION_CLOUD)}
                id={TOWER_MENU_ITEMS.AI_AGENT_PROTECTION_CLOUD}
                title="Access Control"
            />
        </MenuItem>
    );
};
